module.exports = __webpack_public_path__ + "img/ico-option-gray.fbae96d1.svg";